import { Box, ButtonProps, Flex } from '@chakra-ui/react';
import moment from 'moment';
import CurrencyAmount from '../../canopy-ui-components/components/CanopyTable/Cells/CurrencyAmount';
import CanopyTooltip from '../../canopy-ui-components/components/CanopyTooltip/CanopyTooltip';
import { useCurrentColors } from '../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
import EditInfoAction from '../Transactions/EditInfoAction';
export interface ViewTicketProps extends ButtonProps {
    globalProps: GlobalProps;
    data: any;
    columns?: PropTableColumn[];
    refreshData: (args?: any) => void;
}

function ViewTicket({
    globalProps,
    data,
    columns,
    refreshData,
}: ViewTicketProps) {
    const currentColors = useCurrentColors();
    const { t } = globalProps;
    return (
        <>
            {columns?.map(
                ({
                    key,
                    type,
                    headerText,
                    otherKeys,
                    headerTextVariables,
                    dateFormat = 'YYYY-MM-DD',
                    toDateFormat = 'DD/MM/YYYY',
                }) => {
                    const headerTextVariablesObj: Record<string, string> = {};
                    headerTextVariables?.forEach(({ key, value }) => {
                        headerTextVariablesObj[key] = data?.[value];
                    });
                    let date: any;
                    if (type === 'date') {
                        date = moment(data?.[key], dateFormat).format(
                            toDateFormat
                        );
                    }

                    return (
                        <>
                            <Flex
                                direction="row"
                                fontSize="13px"
                                color={currentColors.contentText}>
                                <CanopyTooltip
                                    label={t(
                                        headerText,
                                        headerTextVariablesObj
                                    )}
                                    width="50%"
                                    whiteSpace={'normal'}
                                    minWidth="50%">
                                    {t(headerText, headerTextVariablesObj)}
                                </CanopyTooltip>
                                <Flex width="50%">
                                    {type === 'amount' ? (
                                        data[key] ? (
                                            <CurrencyAmount
                                                align="left"
                                                width="100%"
                                                amount={
                                                    data[key]
                                                }></CurrencyAmount>
                                        ) : (
                                            <Box w="100%">-</Box>
                                        )
                                    ) : type === 'text' ? (
                                        <CanopyTooltip
                                            label={data[key]}
                                            minWidth={'100%'}
                                            whiteSpace={'normal'}>
                                            {data[key] ? data[key] : '-'}
                                        </CanopyTooltip>
                                    ) : type === 'date' ? (
                                        date !== 'Invalid date' ? (
                                            <CanopyTooltip
                                                label={date}
                                                minWidth={'100%'}>
                                                {date}
                                            </CanopyTooltip>
                                        ) : (
                                            <Box>-</Box>
                                        )
                                    ) : type === 'splitCell' ? (
                                        <CanopyTooltip
                                            label={data[key]}
                                            minWidth={'100%'}
                                            whiteSpace={'normal'}>
                                            {data[key] ? data[key] : '-'}
                                        </CanopyTooltip>
                                    ) : type === 'object' && data[key] ? (
                                        <CanopyTooltip
                                            label={data[key]}
                                            minWidth={'100%'}
                                            whiteSpace={'normal'}>
                                            <Flex
                                                direction="row"
                                                width="100%"
                                                justifyContent="space-between">
                                                <Box>
                                                    {Object.entries(data[key])
                                                        .length
                                                        ? Object.entries(
                                                              data[key]
                                                          ).map(
                                                              ([
                                                                  k,
                                                                  value,
                                                              ]: any) => (
                                                                  <Box key={k}>
                                                                      {k}:{' '}
                                                                      {value}
                                                                  </Box>
                                                              )
                                                          )
                                                        : '-'}
                                                </Box>
                                                {key === 'additional_info' && (
                                                    <EditInfoAction
                                                        data={data}
                                                        refreshData={
                                                            refreshData
                                                        }
                                                        globalProps={
                                                            globalProps
                                                        }
                                                    />
                                                )}
                                            </Flex>
                                        </CanopyTooltip>
                                    ) : key === 'additional_info' ? (
                                        <>
                                            <Box width="100%">-</Box>
                                            <EditInfoAction
                                                data={data}
                                                refreshData={refreshData}
                                                globalProps={globalProps}
                                            />
                                        </>
                                    ) : (
                                        '-'
                                    )}
                                </Flex>
                            </Flex>
                            {otherKeys
                                ? otherKeys.map((otherKey) => {
                                      return (
                                          <Flex
                                              direction="row"
                                              fontSize="13px"
                                              color={currentColors.contentText}
                                              key={otherKey}>
                                              <CanopyTooltip
                                                  label={t(
                                                      `table-headers.${otherKey}`
                                                  )}
                                                  width="50%"
                                                  whiteSpace={'normal'}
                                                  minWidth="50%">
                                                  {t(
                                                      `table-headers.${otherKey}`
                                                  )}
                                              </CanopyTooltip>
                                              <Flex width="50%">
                                                  {type === 'amount' ? (
                                                      data[key] ? (
                                                          <CurrencyAmount
                                                              align="left"
                                                              width="100%"
                                                              amount={
                                                                  data[otherKey]
                                                              }></CurrencyAmount>
                                                      ) : (
                                                          <Box w="100%">-</Box>
                                                      )
                                                  ) : type === 'text' ? (
                                                      <CanopyTooltip
                                                          label={data[otherKey]}
                                                          minWidth={'100%'}
                                                          whiteSpace={'normal'}>
                                                          {data[otherKey]
                                                              ? data[otherKey]
                                                              : '-'}
                                                      </CanopyTooltip>
                                                  ) : type === 'date' ? (
                                                      date !==
                                                      'Invalid date' ? (
                                                          <CanopyTooltip
                                                              label={date}
                                                              minWidth={'100%'}>
                                                              {date}
                                                          </CanopyTooltip>
                                                      ) : (
                                                          <Box>-</Box>
                                                      )
                                                  ) : type === 'splitCell' ? (
                                                      <CanopyTooltip
                                                          label={data[otherKey]}
                                                          minWidth={'100%'}
                                                          whiteSpace={'normal'}>
                                                          {data[otherKey]
                                                              ? data[otherKey]
                                                              : '-'}
                                                      </CanopyTooltip>
                                                  ) : null}
                                              </Flex>
                                          </Flex>
                                      );
                                  })
                                : null}
                        </>
                    );
                }
            )}
        </>
    );
}
export default ViewTicket;
